import { GameLuckyNumberData, GameLuckyNumberGeneralData } from '@/components/games/luckynumber/Data';
import { GameIndicator, GameModel } from '@/models/GameModel';

export interface GameLuckyNumberGeneralState {
  defaultValue: string; // backend makes it possible to write an alternative label here.
  maxLength?: number;
  inputLabel?: string;
  submitBtn?: string;
}

export interface GameLuckyNumberState {
  general: GameLuckyNumberGeneralState;
}

export class GameLuckyNumberModel extends GameModel<GameLuckyNumberData, GameLuckyNumberState> {
  parseGame(data: GameLuckyNumberData): void {
    const state = this.state;
    state.general = GameLuckyNumberModel.constructGeneralState(data.general);
  }

  private static constructGeneralState(data: GameLuckyNumberGeneralData): GameLuckyNumberGeneralState {
    return {
      defaultValue: data.default_value ?? '',
      ...(data?.max_length && { maxLength: Number(data.max_length) }),
      ...(data?.input_label && { inputLabel: data.input_label }),
      ...(data?.submit_btn && { submitBtn: data.submit_btn })
    };
  }

  public getIndicators(): GameIndicator[] {
    return [];
  }

  public isGameValid(): boolean {
    // is valid logic here
    // const data = this.getData();
    return true;
  }

  authorSignature(): string {
    return 'Sebastian Jakobsen';
  }
}
